<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    :heading="`Select ${botName}`"
    :width="drawerWidths.md"
    persistent
    :loading="loading"
    v-if="visible"
    data-testid="tasklist__link-bot-drawer"
  >
    <template v-slot:body>
      <div class="link-bot-drawer__body">
        <LinkBotAgentSelect
          :value="selectedBot"
          :bot-list="botList"
          :bot-name="botName"
          data-testid="tasklist__link-bot-dropdown"
          @input="$emit('update:selectedBot', $event)"
        />

        <div
          v-if="selectedBot === 'Lease Schedule'"
          class="link-bot-drawer__section"
          data-testid="tasklist__link-lease-schedule-section"
        >
          <p class="link-bot-drawer__section-label">Select {{ botName }} result(s)</p>
          <div class="link-bot-drawer__lease-options">
            <v-checkbox
              v-for="(lease, index) in leaseScheduleItems || []"
              :key="`${lease || 'lease'}-${index}`"
              color="caccounting"
              :label="lease"
              dense
              class="link-bot-drawer__lease-item"
              :value="lease"
              v-model="leaseScheduleModel"
              multiple
              hide-details
              data-testid="tasklist__link-lease-schedule-checkbox"
            />
          </div>
        </div>

        <div
          v-if="selectedBot === 'Transaction Matching'"
          class="link-bot-drawer__section"
          data-testid="tasklist__link-transaction-matching-section"
        >
          <p class="link-bot-drawer__section-label">Transaction matching analysis</p>
          <lb-dropdown
            :value="selectedTransactionMatching"
            @input="$emit('update:selectedTransactionMatching', $event)"
            label=""
            placeholder="Select transaction matching analysis"
            :items="transactionMatchingList"
            itemtext="name"
            itemvalue="_id"
            data-testid="tasklist__link-transaction-matching-dropdown"
          />
        </div>
      </div>
    </template>

    <template v-slot:actions>
      <LinkBotDrawerActions
        primary-label="Link"
        :primary-disabled="selectedBot === 'Transaction Matching' && !selectedTransactionMatching"
        :loading="loading"
        data-testid="tasklist__link-bot"
        @cancel="closeDrawer"
        @submit="$emit('link')"
      />
    </template>
  </lb-drawer>
</template>

<script>
import { drawerWidths } from '../../../../../../../styles/design-tokens.js';
import LinkBotAgentSelect from '../shared/LinkBotAgentSelect.vue';
import LinkBotDrawerActions from '../shared/LinkBotDrawerActions.vue';
import '../shared/LinkBotDrawer.scss';

export default {
  name: 'LinkBotDrawer',

  components: {
    LinkBotAgentSelect,
    LinkBotDrawerActions,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    botName: {
      type: String,
      default: '',
    },
    selectedBot: {
      type: String,
      default: '',
    },
    botList: {
      type: Array,
      default: () => [],
    },
    leaseScheduleItems: {
      type: Array,
      default: () => [],
    },
    leaseScheduleValue: {
      type: Array,
      default: () => [],
    },
    transactionMatchingList: {
      type: Array,
      default: () => [],
    },
    selectedTransactionMatching: {
      type: String,
      default: '',
    },
  },

  computed: {
    drawerWidths: () => drawerWidths,
    leaseScheduleModel: {
      get() {
        return this.leaseScheduleValue;
      },
      set(value) {
        this.$emit('update:leaseScheduleValue', value);
      },
    },
  },

  methods: {
    closeDrawer() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
